import { render, staticRenderFns } from "./ProfileInfoNew.vue?vue&type=template&id=aa26b88e&"
import script from "./ProfileInfoNew.vue?vue&type=script&lang=js&"
export * from "./ProfileInfoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports